import { render, staticRenderFns } from "./BookingAdd.vue?vue&type=template&id=11bc4f47"
import script from "./BookingAdd.vue?vue&type=script&lang=js"
export * from "./BookingAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports